import React from "react";
import { Box, Modal } from "@mui/material";
import PrimaryBtn from "../../../components/UI/Button/PrimaryBtn";

function ConfirmDeleteModal({ open, closeModal, resetModal, text = '確認済のステータスを解除しますか？' }) {
  return (
    <Modal
      open={open}
      onClose={() => closeModal()}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "360px",
          bgcolor: "white",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
        className="bg-white"
      >
        <div className="mb-6">
          {text}
        </div>

        <div className="w-full h-auto flex items-center justify-end gap-2 flex-wrap">
          <PrimaryBtn
            text={'はい'}
            onClick={() => resetModal()}
          />
          <PrimaryBtn
            text={'いいえ'}
            onClick={() => closeModal()}
          />
        </div>
      </Box>
    </Modal>
  );
}

export default ConfirmDeleteModal;
